import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=f946393c&"
import script from "./AnnouncementList.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports